import {
    streamer,viewer,shop,promotion
} from './request'

// 获取验证码
export const getCode = (mobile) => {
    return streamer.request({
        url:`/api/send-mobile-sms?mobile=${mobile}`,
        method:'post',
        // params:{
        //     mobile
        // }
    })
}

// 验证码登录
export const codeLogin = ({mobile,mobile_verify_code}) => {
    return streamer.request({
        url:'/api/login-mobile',
        method:'post',
        data:{
            mobile,
            mobile_verify_code
        }
    })
}

// 商户登录
export const userLogin = ({username,password}) => {
    return streamer.request({
        url:'/api/login',
        method:'post',
        data:{
            username,
            password
        }
    })
}

// 获取用户信息
export const getUserInfo = () => {
    return streamer.request({
        url:'/api/user/get-user-info',
        method:'get',
    })
}


// 创建推流(直播)
export const createStream = (
  {
    appid,
    live_title='testlive',
    image = 'https://oss.lvtuyanxuan.com/testopen/9lskoRaDBDZilaCg4DQi8ii1zazOsXedsg8ZJDb0.jpg' ,
    time_on = '2025-9-17 20:27:00' ,
    time_out = '2025-10-30 20:27:00'
  }) => {
    return streamer.request({
        url:'/api/stream/create',
        method:'post',
        data:{
            appid,
            live_title,
            image,
            time_on,
            time_out
        }
    })
}

// 修改直播状态
/**
 * @param {stream_name} String  推流名称
 * @param {stream_status} String  0,1,2 0:未开始 1:直播中  2:已结束
 */
export const changeLiveStatus = ({stream_name, stream_status,appid}) => {
    return streamer.request({
        url:'/api/stream/change-status',
        method:'post',
        data:{
            stream_name,
            stream_status,
            appid
        }
    })
}

// 直播数据
/**
 * @param {stream_name} String  推流名称
 */
export const getLiveData = (stream_name, start_time, end_time) => {
    return streamer.request({
        url:`/api/statics/list?stream_name=${stream_name}&start_time=${start_time}&end_time=${end_time}`,
        method:'get',
        // param: {
        //     stream_name,
        //     start_time,
        //     end_time
        // }
    })
}

// 直播间列表
export const liveroomsList = (appid, prepage = 15,page = 1 , time_on) => {
    return streamer.request({
        url:`/api/stream/list?appid=${appid}&per_page=${prepage}&page=${page}&time_on=${time_on}`,
        // url:`/api/stream/list?time_on=${time_on}&time_out=${time_out}`,
        method:'get',
        // param:{
        //     time_on,
        //     time_out,
        //     prepage
        // }
    })
}

// 关闭直播
export const closeLiveroom = (StreamId) => {
    return streamer.request({
        url:`/api/stream/delete/${StreamId}`,
        method:'get'
    })
}

// 直播间弹幕
export const getDanmu = (params) => {
    return streamer.request({
        url:'/api/stream/danmu',
        method:'get',
        params
    })
}

// 直播间禁言
export const Forbidden = ({user_id,stream_name}) => {
    return streamer.request({
        url:'/api/stream/add-user-black-room',
        method:'post',
        data:{
            user_id,
            stream_name
        }
    })
}
export const getProductList = (streamID) => {
    return streamer.request({
        url:'/api/product/list?stream_id='+streamID,
        method:'get',
    })
}
export const SaveProduct = (data) => {
    return streamer.request({
        url:'/api/product/save',
        method:'post',
        data
    })
}
export const deleteProduct = (productID) => {
    return streamer.request({
        url:'/api/product/delete/'+ productID,
        method:'post'
    })
}
export const miaopin_create = (data) => {
    return streamer.request({
        url:'/api/product/create-sku',
        method:'post',
        data
    })
}
export const miaopin_detail = (productID) => {
    return streamer.request({
        url:'/api/product/detail/' + productID,
        method:'get'
    })
}
export const miaopin_swicth_sale_status = (productID) => {
    return streamer.request({
        url:'/api/product/set_on_sale/' + productID,
        method:'post'
    })
}
// 后台
/**
 *  商户注册
 * @param {*} data 
 * @returns 
 */
export function register(data) {
  return shop.request({
    url: '/commercial/register',
    method: 'post',
    data
  })
}
/**
 *  获取商户APPID
 * @returns 
 */
export function getAppid() {
  return shop.request({
    url: '/commercial/get-commercial-applist',
    method: 'get',
  })
}

/**
 *  发送短信
 * @param {*} data 
 * @returns 
 */
export function sendCode({mobile}) {
  return shop.request({
    url: '/commercial/send-mobile-sms',
    method: 'post',
    data: {
      mobile
    }
  })
}

/**
 * @description: 获取商品分类
 */
export function GetGoodsClassify() {
  return shop.request({
    url: '/commercial/product-classify/list',
    method: 'get'
  })
}
/**
 * @description: 获取商品列表
 * @param {number} currentPage --当前页
 * @param {number} per_page -- 每页条数
 * @param {string} where -- 搜索条件
 * @return {*}
 */
export function GetGoodsInfo(page, per_page, where) {
  return shop.request({
    url: '/commercial/product/list',
    method: 'get',
    params: {
      page,
      per_page,
      ...where
    }
  })
}

/**
 * @description: 获取商品详情
 * @param {Numer} name_no -- 商品编号
 * @return {*}
 */
export function GetGoodsDetail(name_no) {
  return shop.request({
    url: '/commercial/product/detail/' + name_no,
    method: 'get'
  })
}

export function listCustomerAccounts(params = {}) {
  return shop.request({
    url: '/commercial/set-site/customer-account-plat/list',
    method: 'get',
    params
  })
}

export function addCustomerAccount(data) {
  return shop.request({
    url: '/commercial/set-site/customer-account-plat/add',
    method: 'post',
    data
  })
}

/**
 * @description: 修改客服账号
{
    "platform": "non",
    "account": "laboriosam",
    "status": 8,
    "config": "qui",
    "remark": "non",
    "nickname": "delectus"  
}
 */
export function updateCustomerAccount(data) {
  return shop.request({
    url: '/commercial/set-site/customer-account-plat/update',
    method: 'post',
    data
  })
}

export function deleteCustomerAccount(id) {
  return shop.request({
    url: '/commercial/set-site/customer-account-plat/del/' + id,
    method: 'delete',
    data: { id }
  })
}

export function listCommercialDomains(params = {}) {
  return shop.request({
    url: '/commercial/domain-bind/list',
    method: 'get',
    params,
  })
}

export function addCommercialDomain(data) {
  return shop.request({
    url: '/commercial/domain-bind/add',
    method: 'post',
    data,
  })
}

export function getCommercialDomainDetail(id) {
  return shop.request({
    url: '/commercial/domain-bind/detail/' + id,
    method: 'get',
  })
}

export function verifyCommercialDomain(id) {
  return shop.request({
    url: '/commercial/domain-bind/verify/' + id,
    method: 'post',
  })
}

export function deleteCommercialDomain(id) {
  return shop.request({
    url: '/commercial/domain-bind/delete/' + id,
    method: 'post',
  })
}



// 文件上传
export function listPromotionCampaigns(params = {}) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns',
    method: 'get',
    params,
  })
}

export function getPromotionCampaign(id, commercialId) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + id,
    method: 'get',
    params: { commercial_id: commercialId },
  })
}

export function createPromotionCampaign(data) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns',
    method: 'post',
    data,
  })
}

export function updatePromotionCampaign(id, data) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + id,
    method: 'patch',
    data,
  })
}

export function savePromotionCampaign(data) {
  const payload = { ...(data || {}) }
  const id = payload.id
  delete payload.id
  return id ? updatePromotionCampaign(id, payload) : createPromotionCampaign(payload)
}

export function setPromotionCampaignStatus({ id, commercial_id, status }) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + id + '/status',
    method: 'patch',
    data: {
      commercial_id,
      status,
    },
  })
}

export function deletePromotionCampaign({ id, commercial_id }) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + id,
    method: 'delete',
    params: { commercial_id },
  })
}

export function createPromotionPaymentOrder(campaignId, commercial_id) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + campaignId + '/payment-orders',
    method: 'post',
    data: {
      commercial_id,
    },
  })
}

export function listCampaignPromotionPaymentOrders(campaignId, params = {}) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + campaignId + '/payment-orders',
    method: 'get',
    params,
  })
}

export function listPromotionPaymentOrders(params = {}) {
  return promotion.request({
    url: '/api/v1/promotions/payment-orders',
    method: 'get',
    params,
  })
}

export function getPromotionPaymentOrder(orderId) {
  return promotion.request({
    url: '/api/v1/promotions/payment-orders/' + orderId,
    method: 'get',
  })
}

export function startPromotionPayment(orderId, payload) {
  const data = typeof payload === 'string'
    ? { channel: payload }
    : { ...(payload || {}) }
  return promotion.request({
    url: '/api/v1/promotions/payment-orders/' + orderId + '/pay',
    method: 'post',
    data,
  })
}

export function cancelPromotionPayment(orderId) {
  return promotion.request({
    url: '/api/v1/promotions/payment-orders/' + orderId + '/cancel',
    method: 'post',
  })
}

export function queryPromotionPaymentStatus(orderId) {
  return promotion.request({
    url: '/api/v1/promotions/payment-orders/' + orderId + '/status',
    method: 'get',
  })
}

export function listNotifications(params = {}) {
  return promotion.request({
    url: '/api/v1/notifications',
    method: 'get',
    params,
  })
}

export function markNotificationRead(id, commercialId) {
  return promotion.request({
    url: '/api/v1/notifications/' + id + '/read',
    method: 'post',
    data: {
      commercial_id: commercialId,
    },
  })
}

export function createNotificationStream(commercialId) {
  const baseURL = String(promotion.defaults.baseURL || '').replace(/\/$/, '')
  const query = new URLSearchParams({ commercial_id: commercialId })
  return new EventSource(`${baseURL}/api/v1/notifications/stream?${query.toString()}`)
}

export function uploadFile(data) {
  return streamer.request({
    url: '/api/filemanager',
    method: 'post',
    data
  })
}

export function uploadPromotionFile(data) {
  return promotion.request({
    url: '/api/v1/uploads/files',
    method: 'post',
    data
  })
}

export const danmuApi = {
    warmupDanmuList(category_id,appid = 1) {
        return streamer.request({
            url:'/api/test-danmu/list',
            method:'get',
            params:{
                appid,
                category_id
            }
        })
    },
    // appid:1 
    // category_id:1  分类ID
    // room_id:1 房间ID
    // timer:60  发送间隔
    // retry_count:3  发送次数
    // task_list:true  true随机  false顺序
    warmupDanmuTaskCreate(data) {
        return streamer.request({
            url:'/api/test-danmu/create-task',
            method:'post',
            data
        })
    },
    warmupDanmuTaskList(room_id) {
        return streamer.request({
            url:'/api/test-danmu/task-list',
            method:'post',
            data:{
                room_id
            }
        })
    },
    warmupDanmuTaskCancel(task_id) {
        return streamer.request({
            url:'/api/test-danmu/task-cancel/' + task_id,
            method:'post',
        })
    },
    // "message": "['测试弹幕1','测试弹幕2']",
    // "category_id": 1,
    // "category_title": "'测试分类'",
    // "appid": 1
    warmupDanmuAdd(data) {
        return streamer.request({
            url:'/api/test-danmu/add-danmu',
            method:'post',
            data
        })
    },
    warmupDanmuDel(id) {
        return streamer.request({
            url:'/api/test-danmu/del-danmu/'+ id,
            method:'post',
        })
    },
}

// 创建红包 POST /api/red-packet/create
export const createRedPacket = (data) => {
  return streamer.request({
    url: '/api/red-packet/create',
    method: 'post',
    data
  })
}

// 发放红包 POST /api/red-packet/give-out
export const giveOutRedPacket = (red_packet_id) => {
  return streamer.request({
    url: '/api/red-packet/give-out',
    method: 'post',
    data: { red_packet_id }
  })
}

// 撤回红包 POST /api/red-packet/revoke
export const revokeRedPacket = (red_packet_id) => {
  return streamer.request({
    url: '/api/red-packet/revoke',
    method: 'post',
    data: { red_packet_id }
  })
}

// 红包列表 GET /api/red-packet/list
// 你 txt 里只写了 list 接口，没有给参数示例；这里做宽松支持：room_id / red_packet_id 可选
export const listRedPackets = (params) => {
  return streamer.request({
    url: '/api/red-packet/list',
    method: 'get',
    params
  })
}

// 红包详情 GET /api/red-packet/detail?red_packet_id=xx
export const redPacketDetail = (red_packet_id) => {
  return streamer.request({
    url: '/api/red-packet/detail',
    method: 'get',
    params: { red_packet_id }
  })
}
